import React from "react";
import ToggleButton from "../components/Toggle";
import Logo from "../components/Logo";

const Header = (props) => {

  const theme=props.theme

  return (
    <header class="d-flex justify-content-between sticky-top p-3 header">
      <div className="my-3">
        <Logo />
      </div>
      <div className="my-auto me-3">
        <ToggleButton theme={theme} switchTheme={props.switchTheme} />
      </div>
    </header>
  );
};

export default Header;
